import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLinksView } from '@/components/ExternalLinks/ExternalLinksView';
import { useLinks } from '@/hooks/useLinks';

export const SchoolLinks: React.FC = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useLinks();

  return (
    <ExternalLinksView
      title={t('sidebar.tabs.schoolLinks')}
      links={data?.schoolLinks}
      isLoading={isLoading}
    />
  );
};
